export type LoaderDotsProps = { variant?: LoaderDotsVariant; baseSize?: number };

export const LoaderDotsVariant = {
  Light: 'light',
  Dark: 'dark',
} as const;
export type LoaderDotsVariant =
  (typeof LoaderDotsVariant)[keyof typeof LoaderDotsVariant];
